import { render, staticRenderFns } from "./SuggestionsView.vue?vue&type=template&id=0f191287&scoped=true&"
import script from "./SuggestionsView.vue?vue&type=script&lang=ts&"
export * from "./SuggestionsView.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionsView.vue?vue&type=style&index=0&id=0f191287&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f191287",
  null
  
)

export default component.exports